<template>
  <div class="job-week h-min-200">
    <div class="row">
      <JobDayHeader
        v-for="day in days"
        v-bind:key="day.id"
        class="col"
        :day_only="true"
        :day_index="day.day"
      />
    </div>
    <div class="row">
      <div v-for="day in days" v-bind:key="day.id" class="col">
        <JobDayDisplay
          :schedule_index="schedule_index"
          :week_index="week_index"
          :day_index="day.day"
          class="col"
          :dragging_enabled="dragging_enabled"
          @toggle_dragging="toggle_dragging"
        />
      </div>
    </div>
  </div>
</template>

<script>
import JobDayDisplay from "@/components/job/JobDayDisplay.vue";
import JobDayHeader from "@/components/job/JobDayHeader.vue";
import { mapState } from "vuex";

export default {
  name: "JobWeekDisplay",
  props: {
    schedule_index: {
      type: Number,
      required: true,
    },
    week_index: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    dragging_enabled: true,
    days: [],
  }),
  mounted() {
    this.$nextTick(() => {
      this.days = this.schedule_group_weeks[this.schedule_index][
        this.week_index
      ].days;
      this.loading = false;
    });
  },
  computed: {
    ...mapState("schedule", ["schedule_group_weeks"]),
  },
  watch: {
    schedule_group_weeks(new_value) {
      this.days = new_value[this.schedule_index][this.week_index].days;
    },
    schedule_index(new_value) {
      this.days = this.schedule_group_weeks[new_value][
        this.week_index % this.schedule_group_weeks[new_value].length
      ].days;
    },
    week_index(new_value) {
      this.days = this.schedule_group_weeks[this.schedule_index][
        new_value
      ].days;
    },
  },
  methods: {
    toggle_dragging() {
      this.dragging_enabled = !this.dragging_enabled;
    },
  },
  components: {
    JobDayHeader,
    JobDayDisplay,
  },
};
</script>
